export default function Image({ src, alt, fill, priority, sizes, className, }) {
    return (<img src={src} alt={alt} className={`${className} ${fill ? 'absolute w-full h-full object-cover' : ''}`} loading={priority ? 'eager' : 'lazy'} sizes={sizes}/>);
}
